/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { FunctionComponent, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';
import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ImageDto, LectionImageDto } from '../../dto/LectionImageDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  formId,
  GetDarkVideoName,
  getDefaultAlertProps,
  getImageVideoSize,
  getPageNumId,
  secureContent,
} from '../../utils/utils';
import {
  API_STATUS_PROBLEM,
  IMAGE_TYPE_BASE_AND_SELECT,
  IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK,
  IMAGE_TYPE_CROP,
  IMAGE_TYPE_MANY,
  IMAGE_TYPE_ONE,
  IMAGE_TYPE_VIDEO,
  IMAGE_TYPE_ZOOM,
  IMAGE_TYPE_ZOOM_VIDEO,
  IMAGE_TYPE_ZOOM_WITH_BLACK,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyButton } from '../UI/MyButton';
import { MyAutoComplete } from '../UI/MuAutoComplete';
import { ImageTypeEnum } from '../../enum/ImageTypeEnum';
import { WorkspaceDto } from '../../dto/WorkspaceDto';
import { RESOURCE_URL } from '../../setting/AppSettings';
import { WorksapceImageItemDiv } from '../workspace/WorksapceImageItemDiv';
import { MyAlert } from '../UI/MyAlert';
import { apiAddImage } from '../../service/apiAddImage';
import { CopyArrDto } from '../../dto/CopyArrDto';
import { DialogCropImage } from './DialogCropImage';
import { MyTextFiled } from '../UI/MyTextField';
import { DialogZoomImage } from './DialogZoomImage';

interface Props {
  idPage: string;
  open: boolean;
  onClose: () => void;
  onSave: (e: any) => void;
  copyDto?: CopyArrDto;
  pageDto?: WorkspaceDto;
}

export const DialogAddImage: FunctionComponent<Props> = ({
  idPage,
  open,
  onClose,
  onSave,
  copyDto,
  pageDto,
}) => {
  const [imageDto, setImageDto] = useState<LectionImageDto>({
    id: '',
    type: 0,
    position: -1,
    descr: '',
    timeBegin: -1,
    zoomImage: {
      name: '',
      base64Image: '',
      zoom: 1,
      coordinate: '',
      height: -1,
      width: -1,
    },
    images: [],
  });

  const [zoom, setZoom] = useState(1);
  const [coordinate, setCoordinate] = useState('');
  const [btnDisabled, setBtnDisabled] = useState(false);

  const [openCropDialog, setOpenCropDialog] = useState(false);
  const [openZoomDialog, setOpenZoomDialog] = useState(false);

  const [imageItemDtos, setImageItemDtos] = useState<ImageDto[]>([]);

  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);
  const handleClose = () => {
    setZoom(1);
    setImageItemDtos([]);
    setImageDto({
      ...imageDto,
      zoomImage: {
        name: '',
        base64Image: '',
        zoom: 1,
        coordinate: '',
        height: -1,
        width: -1,
      },
      id: '',
      timeBegin: 0,
      type: 0,
      images: [],
    });
    setBtnDisabled(false);
    onClose();
  };
  const handleSave = (id: string) => {
    onSave(id);
  };
  const [checkHelper, setCheckHelper] = useState(false);
  const { section, route } = useParams();
  const [selectImageDto, setSelectImageDto] = useState<ImageDto>({
    name: '',
    base64Image: '',
    width: -1,
    height: -1,
    opacity: -1,
    fill: -1,
  });
  const page = getPageNumId(idPage);
  const addImage = async () => {
    let fullName = '';
    for (let i = 0; i < imageItemDtos.length; i += 1) {
      fullName = `${fullName}${imageItemDtos[i].name}${section}${route}`;
    }
    const dtoNewImage = imageDto;
    dtoNewImage.position = copyDto?.start ?? -1;
    dtoNewImage.descr = copyDto?.text ?? '';
    dtoNewImage.id = `${formId(fullName, page || '')}${Math.floor(
      Math.random() * 100
    )}`;
    if (
      dtoNewImage.type === IMAGE_TYPE_CROP ||
      dtoNewImage.type === IMAGE_TYPE_BASE_AND_SELECT
    ) {
      dtoNewImage.zoomImage.coordinate = coordinate;
      dtoNewImage.zoomImage.name = imageItemDtos[1].name;
      dtoNewImage.zoomImage.zoom =
        imageDto.type === IMAGE_TYPE_ZOOM ||
        imageDto.type === IMAGE_TYPE_ZOOM_WITH_BLACK
          ? zoom
          : 1;
      dtoNewImage.images = imageItemDtos.filter(
        (item) => item.name !== imageItemDtos[1].name
      );
    } else if (dtoNewImage.type === IMAGE_TYPE_ZOOM) {
      dtoNewImage.zoomImage.coordinate = coordinate;
      dtoNewImage.zoomImage.name = imageItemDtos[0].name;
      dtoNewImage.zoomImage.zoom =
        imageDto.type === IMAGE_TYPE_ZOOM ||
        imageDto.type === IMAGE_TYPE_ZOOM_WITH_BLACK
          ? zoom
          : 1;
      dtoNewImage.images = imageItemDtos;
    } else if (dtoNewImage.type === IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK) {
      dtoNewImage.zoomImage.coordinate = coordinate;
      dtoNewImage.zoomImage.name = imageItemDtos[0].name;
      dtoNewImage.zoomImage.zoom = 1;
      dtoNewImage.images = imageItemDtos.filter(
        (item) => item.name !== imageItemDtos[0].name
      );
    } else if (dtoNewImage.type === IMAGE_TYPE_ZOOM_WITH_BLACK) {
      dtoNewImage.zoomImage.coordinate = coordinate;
      dtoNewImage.zoomImage.name = imageItemDtos[0].name;
      dtoNewImage.zoomImage.zoom =
        imageDto.type === IMAGE_TYPE_ZOOM ||
        imageDto.type === IMAGE_TYPE_ZOOM_WITH_BLACK
          ? zoom
          : 1;
      dtoNewImage.images = imageItemDtos.filter(
        (item) => item.name !== imageItemDtos[0].name
      );
    } else if (dtoNewImage.type === IMAGE_TYPE_ZOOM_VIDEO) {
      dtoNewImage.zoomImage.coordinate = coordinate;
      dtoNewImage.zoomImage.name = imageItemDtos[0].name;
      dtoNewImage.zoomImage.zoom = zoom;
      dtoNewImage.images = imageItemDtos.filter(
        (item) => item.name !== imageItemDtos[0].name
      );
    } else {
      dtoNewImage.images = imageItemDtos;
    }
    dtoNewImage.timeBegin = 0;
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddImage(
      section ?? '',
      route ?? '',
      page ?? '',
      dtoNewImage
    );
    if (apiResult.isSuccess) {
      handleSave(dtoNewImage.id);
      setBtnDisabled(false);
      setCoordinate('');
      handleClose();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleAdd = async () => {
    setBtnDisabled(true);
    if (imageItemDtos.length === 0) {
      setCheckHelper(true);
      return;
    }
    await addImage();
    setCheckHelper(false);
  };

  const addImageToSelect = (
    text: string,
    widthImage: number,
    heightImage: number
  ) => {
    const dtoImage: ImageDto = {
      name: text,
      base64Image: '',
      width: widthImage,
      height: heightImage,
      fill: 0,
      opacity: 0,
    };
    if (imageDto.type === IMAGE_TYPE_ONE) {
      if (imageItemDtos.length === 0) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_CROP) {
      if (imageItemDtos.length < 2) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_MANY) {
      setImageItemDtos([...imageItemDtos, dtoImage]);
    }
    if (imageDto.type === IMAGE_TYPE_BASE_AND_SELECT) {
      if (imageItemDtos.length < 2) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK) {
      if (imageItemDtos.length < 3) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_VIDEO) {
      if (imageItemDtos.length === 0) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_ZOOM_WITH_BLACK) {
      if (imageItemDtos.length < 3) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_ZOOM) {
      if (imageItemDtos.length === 0) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
    if (imageDto.type === IMAGE_TYPE_ZOOM_VIDEO) {
      if (imageItemDtos.length < 2) {
        setImageItemDtos([...imageItemDtos, dtoImage]);
      }
    }
  };

  const onSaveCrop = (e: any) => {
    addImageToSelect(e.name2, e.w, e.h);
  };

  const onSaveZoom = (width: any, height: any, x: any, y: any) => {
    setCoordinate(`${width}**${height}**${x}**${y}`);
  };

  const onUpdate = (param: string, value: string, dto: ImageDto) => {
    const newDto = imageItemDtos;
    for (let i = 0; i < imageItemDtos.length; i += 1) {
      if (newDto[i].name === dto.name) {
        if (param === 'fill') {
          newDto[i].fill = parseInt(value, 10);
        }
      }
    }
    setImageDto({
      ...imageDto,
      images: newDto,
    });
  };

  const deleteImageFromSelect = (dto: ImageDto) => {
    setImageItemDtos((current) =>
      current.filter((item) => item.name !== dto.name)
    );
  };

  const opedCropEditDialog = (selimage: ImageDto) => {
    setSelectImageDto(selimage);
    setOpenCropDialog(true);
  };
  const opedZoomEditDialog = (selimage: ImageDto) => {
    setSelectImageDto(selimage);
    setOpenZoomDialog(true);
  };

  useEffect(() => {
    setZoom(1);
    setImageItemDtos([]);
    setCheckHelper(false);
  }, []);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%' },
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              Новая ссылка на изображение
            </Typography>
            <IconButton size="medium" onClick={handleClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack padding="0px" spacing={1}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '18px',
                color: '#9c27b0',
              }}
              component="text"
            >
              Ссылка - {copyDto?.text}
            </Typography>
            <MyAutoComplete
              value={
                imageDto.type !== undefined && imageDto.type !== -1
                  ? ImageTypeEnum[imageDto.type]
                  : ''
              }
              onChange={(e, v) => {
                setImageItemDtos([]);
                setImageDto({
                  ...imageDto,
                  type: Object.values(ImageTypeEnum).indexOf(v),
                });
              }}
              maxHeight="500px"
              error={checkHelper}
              arrayList={Object.values(ImageTypeEnum).filter(
                (value) => typeof value === 'string'
              )}
              size="small"
              label="Тип изображения"
            />
            <div style={{ marginTop: '20px' }}> </div>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '16px',
                color: '#9c27b0',
              }}
              component="text"
            >
              Выбранные изображения
            </Typography>
            <Divider />
            {(imageDto.type === IMAGE_TYPE_CROP ||
              imageDto.type === IMAGE_TYPE_BASE_AND_SELECT ||
              imageDto.type === IMAGE_TYPE_ZOOM) && (
              <Grid container spacing={1}>
                {imageDto.type === IMAGE_TYPE_ZOOM && (
                  <Grid item xs={12}>
                    <Stack>
                      <MyTextFiled
                        value={zoom}
                        width="100px"
                        onChange={(e) => setZoom(e.target.value)}
                        type="number"
                        size="small"
                        error={checkHelper}
                        label="Масштаб"
                      />
                    </Stack>
                  </Grid>
                )}
                {imageDto.type !== IMAGE_TYPE_ZOOM && (
                  <Grid item xs={2}>
                    <Typography
                      style={{
                        fontFamily: 'sans-serif',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: '14px',
                        textAlign: 'center',
                        color: '#000000',
                      }}
                      component="text"
                    >
                      Базовое изображения
                    </Typography>
                  </Grid>
                )}
                {imageDto.type !== IMAGE_TYPE_ZOOM && (
                  <Grid item xs={2}>
                    <Typography
                      style={{
                        fontFamily: 'sans-serif',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: '14px',
                        textAlign: 'center',
                        color: '#000000',
                      }}
                      component="text"
                    >
                      Выделенная часть
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
            {imageDto.type === IMAGE_TYPE_ZOOM_WITH_BLACK && (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Stack>
                    <MyTextFiled
                      value={zoom}
                      width="100px"
                      onChange={(e) => setZoom(e.target.value)}
                      type="number"
                      size="small"
                      error={checkHelper}
                      label="Масштаб"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Базовое изображения
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Без цвета
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Выделенный элемент
                  </Typography>
                </Grid>
              </Grid>
            )}
            {imageDto.type === IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK && (
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Базовое изображения
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Без цвета
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Выделенный элемент
                  </Typography>
                </Grid>
              </Grid>
            )}
            {imageDto.type === IMAGE_TYPE_ZOOM_VIDEO && (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Stack>
                    <MyTextFiled
                      value={zoom}
                      width="100px"
                      onChange={(e) => setZoom(e.target.value)}
                      type="number"
                      size="small"
                      error={checkHelper}
                      label="Масштаб"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Базовое изображения
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#000000',
                    }}
                    component="text"
                  >
                    Видео
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={1}>
              {imageItemDtos?.map((item, index) => (
                <WorksapceImageItemDiv
                  idPage={idPage}
                  indexImage={index}
                  imageType={imageDto.type}
                  zoomparam={1}
                  dto={item}
                  onCrop={opedCropEditDialog}
                  onZoom={opedZoomEditDialog}
                  onClick={deleteImageFromSelect}
                  onUpdate={onUpdate}
                />
              ))}
            </Grid>
            <Stack paddingTop="20px" alignItems="center">
              <MyButton
                disabled={btnDisabled}
                width="150px"
                text="Добавить"
                background="#9c27b0"
                height="50px"
                onClick={handleAdd}
              />
            </Stack>
            <div style={{ marginTop: '20px' }}> </div>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '16px',
                color: '#000000',
              }}
              component="text"
            >
              Доступные изображения
            </Typography>
            <Divider />
            <Grid container spacing={1}>
              {pageDto!.images.map((item) => (
                <>
                  {item.name.includes('.png') &&
                    imageDto.type !== IMAGE_TYPE_VIDEO && (
                      <Grid
                        item
                        xs={2}
                        onClick={() =>
                          addImageToSelect(item.name, item.width, item.height)
                        }
                      >
                        <Card style={{ width: '100%' }}>
                          <Stack alignItems="center">
                            <img
                              width={getImageVideoSize(item, 200, 200)[0]}
                              height={getImageVideoSize(item, 200, 200)[1]}
                              alt="not found"
                              src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                                item.name
                              }&${secureContent()}`}
                            />
                          </Stack>
                          <div
                            style={{
                              padding: '10px',
                              fontSize: '12px',
                            }}
                          >
                            {GetDarkVideoName(
                              item.name,
                              pageDto!.videoMetadata
                            )}
                          </div>
                        </Card>
                      </Grid>
                    )}
                  {item.name.includes('.mp4') &&
                    (imageDto.type === IMAGE_TYPE_VIDEO ||
                      imageDto.type === IMAGE_TYPE_ZOOM_VIDEO) && (
                      <Grid
                        item
                        xs={2}
                        onClick={() =>
                          addImageToSelect(item.name, item.width, item.height)
                        }
                      >
                        <Card style={{ width: '100%' }}>
                          <video width="100%" playsInline autoPlay muted loop>
                            <source
                              src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                                item.name
                              }&${secureContent()}`}
                              type="video/mp4"
                            />
                          </video>
                          <div
                            style={{
                              padding: '10px',
                              fontSize: '12px',
                            }}
                          >
                            {GetDarkVideoName(
                              item.name,
                              pageDto!.videoMetadata
                            )}
                          </div>
                        </Card>
                      </Grid>
                    )}
                </>
              ))}
            </Grid>
          </Stack>
        </DialogContent>
      </Dialog>
      <DialogCropImage
        idPage={idPage}
        open={openCropDialog}
        dto={selectImageDto}
        onSave={onSaveCrop}
        onClose={() => setOpenCropDialog(false)}
      />
      <DialogZoomImage
        idPage={idPage}
        open={openZoomDialog}
        dto={selectImageDto}
        onSave={onSaveZoom}
        onClose={() => setOpenZoomDialog(false)}
      />
    </div>
  );
};

DialogAddImage.defaultProps = {
  copyDto: undefined,
  pageDto: undefined,
};
